/**
 * Identifier normalization — Festipod's OWN handle → key mapping.
 *
 * Nothing here is lent to the SDK. Normalizing identities is the SDK's own affair
 * (`@Alice`, `alice ` and `ALICE` are one person to it, and it needs no hook from
 * us to say so). What remains is a Festipod comparison: a profile's `username` is
 * an app field, typed by a human, and the app matches it against the signed-in
 * principal and against peer keys in its own relationship graph. That is the sole
 * remaining caller (`FestipodDataContext`).
 */

/** Trim, strip leading `@`, lowercase — the canonical form of a handle. */
export function normalizeIdentifier(identifier: string | null | undefined): string {
  return (identifier ?? '').trim().replace(/^@+/, '').toLowerCase();
}
